import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserData, UserRole } from 'src/app/models/user-data.model';
import { AppAuthService } from '../app/auth.service';
import { OfficesService } from './franchises.service';
import { DirectoryUser } from '@/models/directory-user.model';


@Injectable({
  providedIn: 'root'
})
export class UserRolesListService {
  roles = signal<UserRole[]>([]);

  constructor(
    private appAuthSevice:AppAuthService,
    private officesService:OfficesService,

  ) { }

  setRoles(newRoles: UserRole[]) {
    this.roles.set(newRoles)
    console.log('new roles', newRoles);
  }

  combineRoles(profile: UserData) {
    if (profile.UserRoles) {
      this.setRoles(profile.UserRoles)
    }
  }

  addInviteRoles(profile: UserData) {
    console.log('searching for invites in profile', profile)
    if (profile.officeInvites_officeInvites_targetUserToUsers) {
      profile.officeInvites_officeInvites_targetUserToUsers.forEach(role => {
        role.inviteRoles.forEach(invite => {
          const existingRole = this.roles().find(r => r.PermRoleID === (invite.PermRoles.PermRoleID));
          if (!existingRole) {
            let newRole = invite.PermRoles
              newRole.RoleName = newRole.RoleName + ' (Invite Pending)'
          const userRole: UserRole = {
            UID: profile.UID,
            PermRoleID: invite.PermRoles.PermRoleID,
            UserRoleID: 0,
            PermRoles: newRole,
            inviteRole: true,
            invite: role
          }
          this.roles.set([...this.roles(), userRole]);
        }
      });
    });
  }
}

filterDirectoryRoles(user: DirectoryUser, profile: UserData ) {
  console.log('user', user)
  this.roles.set([]);
  let roles: UserRole[] = [];
  this.officesService.getFIDsByTableName(profile, 'UserRoles', ['edit']).subscribe(list => {
    const officeList = list['edit']
    console.log('officeList', officeList)

    if (officeList) {
      if (officeList.includes(5)) {
        console.log('5 in officeList')
        roles = user.UserRoles?.filter(
          u => u.PermRoles.FID !== null
        ) || [];
      }
      else {
        roles = user.UserRoles?.filter(
          u => u.PermRoles.FID !== null && officeList.includes(u.PermRoles.FID)
        ) || [];
        const nullRoles = user.UserRoles?.filter(
          u => u.PermRoles.FID === null
        );
        if (nullRoles) {
          roles.push(...nullRoles)
        }
        console.log('filtered roles', roles)
      }
    }
    this.setRoles(roles);
    // this.addInviteRoles(user)
  }
  );
}

  filterRoles(user: UserData, profile: UserData ) {
    console.log('user', user)
    this.roles.set([]);
    let roles: UserRole[] = [];
    this.officesService.getFIDsByTableName(profile, 'UserRoles', ['edit']).subscribe(list => {
      const officeList = list['edit']
      console.log('officeList', officeList)

      if (officeList) {
        if (officeList.includes(5)) {
          console.log('5 in officeList')
          roles = user.UserRoles?.filter(
            u => u.PermRoles.FID !== null
          ) || [];
        }
        else {
          roles = user.UserRoles?.filter(
            u => u.PermRoles.FID !== null && officeList.includes(u.PermRoles.FID)
          ) || [];
          const nullRoles = user.UserRoles?.filter(
            u => u.PermRoles.FID === null
          );
          if (nullRoles) {
            roles.push(...nullRoles)
          }
          console.log('filtered roles', roles)
        }
      }
      this.setRoles(roles);
      this.addInviteRoles(user)
    }
    );
  }

  addRoleTemp(role: UserRole) {
    const roleCopy = JSON.parse(JSON.stringify(role));
    roleCopy.PermRoles.RoleName = roleCopy.PermRoles.RoleName + ' (Pending)';
    const currentRoles = this.roles();
    this.roles.set([...currentRoles, roleCopy]);
  }


  removeRole(role: UserRole) {
    const currentRoles = this.roles();
    const newRoles = currentRoles.filter(r => r.PermRoleID !== role.PermRoleID);
    this.roles.set(newRoles);
  }
}
